export default {
  BT_HDP: "แฮนดิแคป  | HDP",
  BT_OU: "สูง/ต่ำ | O/U",
  BT_ML: "มันนี่ไลน์",
  BT_1X2: "1X2",
  BT_1X2HDP: "แฮนดิแคป 3 ทาง",
  BT_CS: "ทายผลสกอร์",
  BT_OE: "คี่/คู่ | O/E",
  BT_DC: "สองโอกาส",
  BT_HTFT: "ครึ่งเวลา/เต็มเวลา",
  BT_FGLG: "ประตูแรก/สุดท้าย",
  BT_TG: "จำนวนประตูทั้งหมด",
  BT_OR: "ทายผลผู้ชนะ",
  BT_ORZ: "ทายผลผู้ชนะ",

  BT_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BT_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BT_CL: "ไม่เสียประตู",
  BT_DNB: "เสมอไม่เดิมพัน",
  BT_DNBH: "ครึ่งเวลา เสมอไม่เดิมพัน",
  BT_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BT_TWTN: "ชนะโดยไม่เสียประตู",

  BT_HDPF: "เต็มเวลา แฮนดิแคป  | เต็มเวลา. HDP",
  BT_OUF: "เต็มเวลา สูง/ต่ำ | เต็มเวลา O/U",
  BT_MLF: "เต็มเวลา มันนี่ไลน์",
  BT_1X2F: "เต็มเวลา 1X2",
  BT_1X2HDPF: "เต็มเวลา แฮนดิแคป 3 ทาง",
  BT_CSF: "เต็มเวลา ทายผลสกอร์",
  BT_OEF: "เต็มเวลา คี่/คู่ | เต็มเวลา O/E",
  BT_DCF: "เต็มเวลา สองโอกาส",
  BT_FGLGF: "เต็มเวลา ประตูแรก/สุดท้าย",
  BT_TGF: "เต็มเวลา จำนวนประตูทั้งหมด",

  BT_HDPH: "ครึ่งเวลา แฮนดิแคป  | ครึ่งเวลา. HDP",
  BT_OUH: "ครึ่งเวลา สูง/ต่ำ | ครึ่งเวลา O/U",
  BT_MLH: "ครึ่งเวลา มันนี่ไลน์",
  BT_1X2H: "ครึ่งเวลา 1X2",
  BT_1X2HDPH: "ครึ่งเวลา แฮนดิแคป 3 ทาง",
  BT_CSH: "ครึ่งเวลา ทายผลสกอร์",
  BT_OEH: "ครึ่งเวลา  คี่/คู่ | ครึ่งเวลา O/E",
  BT_DCH: "ครึ่งเวลา สองโอกาส",
  BT_FGLGH: "ครึ่งเวลา ประตูแรก/สุดท้าย",
  BT_TGH: "ครึ่งเวลา จำนวนประตูทั้งหมด",
  BT_O: "สูง",
  BT_U: "ต่ำ",

  BT_HDPOU: "แฮนดิแคป & สูง/ต่ำ",
  BT_PARLAY: "มิกซ์ พาร์เลย์",
  BT_FT: "เต็มเวลา. ",
  BT_1H: "ครึ่งแรก. ",
  BT_2H: "ครึ่งหลัง. ",

  BT_FG: "ประตูแรก",
  BT_LG: "ประตูสุดท้าย",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "ไม่มีประตู",
  BT_HY: "เจ้าบ้าน ไม่เสียประตู",
  BT_HN: "เจ้าบ้าน เสียประตู",
  BT_AY: "ทีมเยือน ไม่เสียประตู",
  BT_AN: "ทีมเยือน เสียประตู",
  BT_H: "เจ้าบ้าน",
  BT_A: "ทีมเยือน",
  BT_D: "เสมอ",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "ใช่",
  BT_N: "ไม่มี",

  BT_LIVE: "สด",
  BT_HT: "ครึ่งแรก",
  BT_DELAYED: "DELAY",
  BT_PEN: "PEN",

  BT_FT1: "เต็มเวลา.1",
  BT_FT2: "เต็มเวลา.2",
  BT_FTX: "เต็มเวลา.X",
  BT_HT1: "ครึ่งเวลา.1",
  BT_HT2: "ครึ่งเวลา.2",
  BT_HTX: "ครึ่งเวลา.X",

  BT_BOTH: "ทั้งคู่",
  BT_ONE: "หนึ่ง",

  BS_HDP: "เต็มเวลา แฮนดิแคป",
  BS_HDPH: "ครึ่งเวลา แฮนดิแคป",
  BS_OU: "เต็มเวลา สูง/ต่ำ",
  BS_OUH: "ครึ่งเวลา สูง/ต่ำ",
  BS_OE: "เต็มเวลา คี่/คู่",
  BS_OEH: "ครึ่งเวลา คี่/คู่",
  BS_1X2: "เต็มเวลา 1X2",
  BS_1X2H: "ครึ่งเวลา 1X2",
  BS_ML: "เต็มเวลา มันนี่ไลน์",
  BS_MLH: "ครึ่งเวลา มันนี่ไลน์",
  BS_1X2HDP: "เต็มเวลา แฮนดิแคป 3 ทาง",
  BS_1X2HDPH: "ครึ่งเวลา แฮนดิแคป 3 ทาง",
  BS_CS: "เต็มเวลา ทายผลสกอร์",
  BS_CSH: "ครึ่งเวลา ทายผลสกอร์",
  BS_DC: "เต็มเวลา สองโอกาส",
  BS_DCH: "ครึ่งเวลา สองโอกาส",
  BS_FGLG: "เต็มเวลา ประตูแรก/สุดท้าย",
  BS_FGLGH: "ครึ่งเวลา ประตูแรก/สุดท้าย",
  BS_TG: "เต็มเวลา จำนวนประตูทั้งหมด",
  BS_TGH: "ครึ่งเวลา จำนวนประตูทั้งหมด",
  BS_ANB: "ไม่มีการวางเดิมพันทีมเยือน",
  BS_HTFT: "ครึ่งเวลา/เต็มเวลา",
  BS_BS: "ทั้งสองทีม/หนึ่งทีม/ไม่มีทีมใดที่ทำคะแนนได้",
  BS_CL: "ไม่เสียประตู",
  BS_DNB: "เสมอไม่เดิมพัน",
  BS_DNBH: "ครึ่งเวลา เสมอไม่เดิมพัน",
  BS_HNB: "ไม่มีการวางเดิมพันทีมเหย้า",
  BS_TWTN: "ชนะโดยไม่เสียประตู",
  BS_OR: "ทายผลผู้ชนะ",
  BS_ORZ: "ทายผลผู้ชนะ",
  
  LOT_BS: "ใหญ่/เล็ก",
  LOT_BIG: "ใหญ่",
  LOT_SMALL: "เล็ก",
  LOT_OE: "คี่/คู่",
  LOT_ODD: "คี่",
  LOT_EVEN: "คู่",
  LOT_OU: "สูง/ต่ำ",
  LOT_OVER: "สูง",
  LOT_UNDER: "ต่ำ",
  LOT_FT: "เต็มเวลา",
  LOT_HT: "ครึ่งเวลา",

  BT_ALLBT: "ประเภทการเดิมพันทั้งหมด",
  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "วิธีชนะ",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "OVER (4,5,6)",
  GH_UNDER: "UNDER (1,2,3)",
  GH_ODD: "ODD (1,3,5)",
  GH_EVEN: "EVEN (2,4,6)",
  GH_OU1: "OVER (4,5,6)",
  GH_OU2: "UNDER (1,2,3)",
  GH_OE1: "ODD (1,3,5)",
  GH_OE2: "EVEN (2,4,6)",

  ROOM_A: "Open",
  ROOM_0: "Active",
  ROOM_1: "Closed",
  ROOM_2: "Cancel",
  ROOM_3: "Ended",
  ROOM_4: "Stop Betting",
  ROOM_10: "All",

  ROOM_T0: "All",
  ROOM_T1: "Public Room",
  ROOM_T2: "Private Room",
  ROOM_T3: "Play to Earn",

  joinRoom1: "Join Public Room",
  joinRoom2: "Join Private Room",
  joinRoom3: "Join Play Room",
  createRoom1: "Create Public Room",
  createRoom2: "Create Private Room",
  createRoom3: "Create Play Room",
  Champion: "Champion",
  FirstRunnerUp: "First Runner Up",
  SecondRunnerUp: "Second Runner Up",

  BT_OEHM: "Home Odd/Even | Home O/E",
  BT_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BT_OEAW: "Away Odd/Even | Away O/E",
  BT_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  BS_OEHM: "FT. Home Odd/Even | FT. Home O/E",
  BS_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BS_OEAW: "FT. Away Odd/Even | FT. Away O/E",
  BS_OEAWH: "FH. Away Odd/Even | FH. Away O/E",
  
  MB_OVER: "OVER (4,5,6)",
  MB_UNDER: "UNDER (1,2,3)",
  MB_ODD: "ODD (1,3,5)",
  MB_EVEN: "EVEN (2,4,6)",
};